module.exports = __webpack_public_path__ + "img/lnupskill.4325429a.avif";